import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["ResponseForm"], {
    close: $props.close,
    info: $props.info
  }, null, 8, ["close", "info"]))
}